import { faMoon, faSun } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@/components/shared/IconButton';
import { useTranslator } from '@/hooks/useTranslator';
import { useThemeStore } from '@/store/themeStore';

export function AppHeaderThemeToggle() {
  const { theme, setThemeAnimated } = useThemeStore();
  const { getTranslation } = useTranslator({ page: 'appHeader' });

  const dark =
    theme === 'dark' ||
    (theme === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <IconButton
      variant='ghost'
      size='icon'
      className='h-7.5 w-7.5 text-muted-foreground'
      tooltip={getTranslation('toggleTheme')}
      data-tour='theme'
      onClick={e => {
        // The reveal animation radiates from the button that started it.
        const rect = e.currentTarget.getBoundingClientRect();
        setThemeAnimated(
          dark ? 'light' : 'dark',
          rect.left + rect.width / 2,
          rect.top + rect.height / 2,
        );
      }}
    >
      {dark ? (
        <FontAwesomeIcon icon={faMoon} className='size-3.5' />
      ) : (
        <FontAwesomeIcon icon={faSun} className='size-3.5' />
      )}
    </IconButton>
  );
}
